import BrowserChrome from './BrowserChrome';

export default function ViennaBefore() {
  return (
    <BrowserChrome url="viennaaquariumandpets.com">
      <div className="ugly" style={{ background: '#fffcee' }}>
        <div
          className="banner"
          style={{
            background: 'linear-gradient(180deg,#0c7a3a,#054320)',
            borderColor: '#031b0d',
          }}
        >
          <h3>Vienna Aquarium & Pets</h3>
          <span className="tag">Since 2005</span>
        </div>
        <nav style={{ background: '#ffe45a', borderBottomColor: '#b39200' }}>
          {['Home', 'Fish', 'Reptiles', 'Small Animals', 'Supplies', 'Services', 'Contact Us'].map(
            // Decorative mock nav — see HeroBeforeMock for why <span>.
            (l) => <span key={l}>{l}</span>,
          )}
        </nav>
        <div className="row">
          <div
            className="hero-box"
            style={{
              background: '#e4f5e4',
              backgroundImage:
                'repeating-linear-gradient(45deg,#e4f5e4,#e4f5e4 8px,#d0ebd0 8px,#d0ebd0 16px)',
            }}
          >
            <h2 style={{ color: '#0c7a3a' }}>Welcome to Vienna Aquarium!</h2>
            <p>
              Your one-stop shop for all pet needs since 2005! We carry a huge selection of fish,
              reptiles, small animals and supplies at competitive prices!
            </p>
            <img alt="" style={{ background: '#6e9cb3' }} />
            <p className="blink">★ NEW ARRIVALS EVERY WEEK ★</p>
          </div>
          <div className="side" style={{ background: '#fff3a0' }}>
            <h4>Store Hours</h4>
            <ul>
              <li>Mon–Fri: 10–8</li>
              <li>Sat: 10–7</li>
              <li>Sun: 12–5</li>
            </ul>
            <div className="counter">Hits: 0082914</div>
          </div>
        </div>
        <div className="foot">© Vienna Aquarium • Designed 2006</div>
      </div>
    </BrowserChrome>
  );
}
